import { useEffect, useRef } from "react";

export function useInterval() {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => clear, []);

  function set(func: VoidFunction, time: number) {
    clear();
    intervalRef.current = setInterval(func, time);
  }

  function clear() {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }

  return {
    set,
    clear,
    isRunning: intervalRef.current !== null,
  };
}
